import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Menu from '../menu/Menu';
import Header from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Titulo from '../titulo/Titulo';
import CardNovoEvento from './card/CardNovoEvento';
import CardEventos from './card/CardEventos';
import ModalConfirmacao from '../modal/ModalConfirmacao';
import Snackbar from '../common/Snackbar';
import EventosService from '../../service/eventos/EventosService';

// Styled Components copied/adapted from Designacoes
const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px; // Adjust based on Header height
  margin-bottom: 50px; // Adjust based on Footer height
`;

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 240px; 
  padding: clamp(1rem, 2vh, 1.5rem) clamp(1rem, 2.5vw, 2rem);
  box-sizing: border-box;

  @media (max-width: 1200px) {
    margin-left: 60px;
    padding-left: 20px;
  }

  @media (max-width: 767.98px) {
    margin-left: 0;
    padding-left: clamp(1rem, 4vw, 2rem);
  }
`;

const Content = styled.main`
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  align-items: stretch; 
  gap: clamp(0.75rem, 2vw, 1rem);
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1200px) {
    margin: 0;
    max-width: none;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
  }
`;

const BlocoTituloCards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 1.6vh, 1rem);
  flex: 1;
  min-height: 0;
  overflow: hidden;
  transition: margin .2s ease;

  @media (max-width: 768px) {
    overflow: visible;
    flex: none;
  }
`;

const PageTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding-top: clamp(0.375rem, 0.8vh, 0.75rem);
`;

const ExcluirButton = styled.button`
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap; 

  &:hover {
    background-color: #006666;
  }
`;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: clamp(1rem, 2.5vw, 1.5rem);
  row-gap: clamp(1.1rem, 3vw, 1.75rem);
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  grid-auto-rows: 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    overflow: visible;
    flex: none;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: calc(100dvh - 85px - 50px - 7rem);
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    max-height: none;
    height: auto;
    min-height: 0;
  }
`;

const CardHeader = styled.div`
  background: #00aaaa;
  color: #f1f7f9;
  padding: 9px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 16px;
  font-weight: 500;
`;

const CardBody = styled.div`
  padding: clamp(0.75rem, 2vw, 1.25rem) clamp(1rem, 3vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: 7px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media (max-width: 768px) {
    overflow-y: visible;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;

  label {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

const CampoInput = styled.input`
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #c5c5c5;
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  background: #fdfdfd;

  &:focus {
      border-color: #00aaaa;
  }
`;

const CampoTextArea = styled.textarea`
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #c5c5c5;
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  background: #fdfdfd;

  &:focus {
      border-color: #00aaaa;
  }
`;

const GravarButton = styled.button`
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  width: 25%;

  &:hover {
    background-color: #006666;
  }

  @media (max-width: 560px) {
    width: 100%;
    padding: 12px;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const CancelarButton = styled.button`
  background-color: #e0e0e0;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  width: 25%;
  font-weight: 500;

  &:hover {
    background-color: #c4c4c4;
  }

  @media (max-width: 560px) {
    width: 100%;
    padding: 12px;
    font-size: clamp(15px, 3.8vw, 17px);
  }
`;

const AddButton = styled.button`
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  
  &:hover {
      background-color: #006666;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
  font-size: 13px;
`;

const sortEventosByNome = (lista = []) => {
  return [...lista].sort((a, b) => {
    const nomeA = (a?.nome || a?.titulo || '').trim();
    const nomeB = (b?.nome || b?.titulo || '').trim();
    return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
  });
};


const Eventos = () => {
    const perfisUsuario = (() => {
      try { return JSON.parse(localStorage.getItem('perfilUsuario') || '[]'); } catch { return []; }
    })();
    const isSecretaria = perfisUsuario.includes('secretaria') && !perfisUsuario.includes('administrador');

    const [eventos, setEventos] = useState([]);
    const [loadingEventos, setLoadingEventos] = useState(true);
    const [eventoEmEdicao, setEventoEmEdicao] = useState(null);
  const [eventosSelecionados, setEventosSelecionados] = useState([]);
  const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
  const [eventoParaExcluir, setEventoParaExcluir] = useState(null);
  const [snackbar, setSnackbar] = useState({ aberto: false, mensagem: '', tipo: 'success' });
  const containerRef = useRef(null);

    const mostrarSnackbar = (mensagem, tipo = 'success') => {
      setSnackbar({ aberto: true, mensagem, tipo });
    };

    const fecharSnackbar = () => {
      setSnackbar((prev) => ({ ...prev, aberto: false }));
    };

    const fecharModalExclusao = () => {
      setModalExcluirAberto(false);
      setEventoParaExcluir(null);
    };

    useEffect(() => {
        loadEventos();
    }, []);

    const loadEventos = async () => {
        try {
        setLoadingEventos(true);
            const data = await EventosService.getEventos();
            if (Array.isArray(data)) {
                 // Ordenação padrão após recarregar: por nome
                const sorted = sortEventosByNome(data);
                 setEventos(sorted);
            }
        } catch (error) {
            console.error('Erro ao carregar eventos:', error);
            setEventos([]);
      } finally {
        setLoadingEventos(false);
        }
    };

    const handleGravar = async (eventoCriado) => {
      // Na criação, o evento novo deve aparecer no topo imediatamente.
      if (eventoCriado && eventoCriado._id) {
        setEventos((prev) => [eventoCriado, ...prev.filter((evento) => evento._id !== eventoCriado._id)]);
        return;
      }

      // Em atualização, recarrega a lista já ordenada por nome.
      await loadEventos();
    };

    const handleExcluir = (id) => {
      setEventoParaExcluir(id);
      setModalExcluirAberto(true);
    };

    const handleToggleSelecionado = (id) => {
      setEventosSelecionados((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    };

    const executarExclusaoSelecionados = async () => {
      try {
        if (eventoParaExcluir) {
          await EventosService.deleteEvento(eventoParaExcluir);

          if (eventoEmEdicao && eventoEmEdicao._id === eventoParaExcluir) {
            setEventoEmEdicao(null);
          }

          setEventosSelecionados((prev) => prev.filter((id) => id !== eventoParaExcluir));
          mostrarSnackbar('Evento excluído com sucesso.', 'success');
        } else {
          for (const id of eventosSelecionados) {
            await EventosService.deleteEvento(id);
          }

          if (eventoEmEdicao && eventosSelecionados.includes(eventoEmEdicao._id)) {
            setEventoEmEdicao(null);
          }

          setEventosSelecionados([]);
          mostrarSnackbar('Eventos excluídos com sucesso.', 'success');
        }
        await loadEventos();
      } catch (error) {
        const mensagem = eventoParaExcluir
          ? 'Erro ao excluir evento. Tente novamente.'
          : 'Erro ao excluir eventos. Tente novamente.';
        mostrarSnackbar(mensagem, 'error');
      } finally {
        fecharModalExclusao();
      }
    };

    const handleEditar = (evento) => {
        setEventoEmEdicao(evento);
        setTimeout(() => {
          containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
    };

     const handleCancelarEdicao = () => {
        setEventoEmEdicao(null);
    };

    return (
        <PageWrapper>
            <Header />
            <MainContentWrapper>
                <Menu />
                <Container ref={containerRef}>
                    <Content>
                        <BlocoTituloCards>
                            <PageTitleWrapper>
                                <Titulo>Eventos</Titulo>
                                {!isSecretaria && (
                                <ExcluirButton
                                  onClick={() => {
                                    if (!eventosSelecionados.length) {
                                      mostrarSnackbar('Selecione pelo menos um evento para excluir.', 'warning');
                                      return;
                                    }
                                    setEventoParaExcluir(null);
                                    setModalExcluirAberto(true);
                                  }}
                                >
                                  {eventosSelecionados.length > 0
                                    ? `Excluir (${eventosSelecionados.length})`
                                    : 'Excluir'}
                                </ExcluirButton>
                                )}
                            </PageTitleWrapper>
                            
                            <CardsWrapper style={isSecretaria ? { gridTemplateColumns: '1fr' } : {}}>
                                {!isSecretaria && (
                                <CardNovoEvento 
                                    styles={{
                                  Card, CardHeader, CardBody, FormGroup, GravarButton, CancelarButton, CampoInput, CampoTextArea, AddButton, CheckboxWrapper
                                    }}
                                    eventoEmEdicao={eventoEmEdicao}
                                    handleGravar={handleGravar}
                                    handleCancelarEdicao={handleCancelarEdicao}
                                    eventos={eventos}
                                />
                                )}
                                
                                <CardEventos
                                    styles={{
                                        Card, CardHeader, CardBody
                                    }}
                                    eventos={eventos}
                                  loading={loadingEventos}
                                    handleExcluir={handleExcluir}
                                    handleEditar={handleEditar}
                                    onEventoAtualizado={loadEventos}
                                  eventosSelecionados={eventosSelecionados}
                                  onToggleSelecionado={handleToggleSelecionado}
                                />
                            </CardsWrapper>
                        </BlocoTituloCards>
                    </Content>
                </Container>
            </MainContentWrapper>
            <ModalConfirmacao
              isOpen={modalExcluirAberto}
              onClose={fecharModalExclusao}
              onConfirm={executarExclusaoSelecionados}
              titulo="Confirmar Exclusão"
              mensagem={
                eventoParaExcluir
                  ? 'Deseja confirmar a exclusão deste evento?'
                  : eventosSelecionados.length === 1
                  ? 'Deseja confirmar a exclusão de 1 evento selecionado?'
                  : `Deseja confirmar a exclusão de ${eventosSelecionados.length} eventos selecionados?`
              }
            />
            {snackbar.aberto && (
              <Snackbar
                mensagem={snackbar.mensagem}
                tipo={snackbar.tipo}
                onClose={fecharSnackbar}
              />
            )}
            <Rodape />
        </PageWrapper>
    );
};

export default Eventos;
